export enum RoleRights {
    READ = 'Read',
    EDIT = 'Edit',
    ADMIN = 'Admin',
    GXP_EDIT = 'GxP.Edit'
}

export enum Roles {
    EBE_READ = 'NGS.EBE.Read',
    EBE_EDIT = 'NGS.EBE.Edit',
    EBE_ADMIN = 'NGS.EBE.Admin',
    EBE_GXP = 'NGS.EBE.GxP.Edit',
    MICRO_ARRAY_EBE_READ = 'MICRO_ARRAY.EBE.Read',
    MICRO_ARRAY_EBE_EDIT = 'MICRO_ARRAY.EBE.Edit',
    MICRO_ARRAY_EBE_ADMIN = 'MICRO_ARRAY.EBE.Admin',
    MICRO_ARRAY_EBE_GXP = 'MICRO_ARRAY.EBE.GxP.Edit',
    MICRO_ARRAY_GAL_READ = 'MICRO_ARRAY.GAL.Read',
    MICRO_ARRAY_GAL_EDIT = 'MICRO_ARRAY.GAL.Edit',
    MICRO_ARRAY_GAL_ADMIN = 'MICRO_ARRAY.GAL.Admin',
    NGS_GAL_READ = 'NGS.GAL.Read',
    NGS_GAL_EDIT = 'NGS.GAL.Edit',
    NGS_GAL_ADMIN = 'NGS.GAL.Admin',
    MICRO_ARRAY_SKB_READ = 'MICRO_ARRAY.SKB.Read',
    MICRO_ARRAY_SKB_EDIT = 'MICRO_ARRAY.SKB.Edit',
    MICRO_ARRAY_SKB_ADMIN = 'MICRO_ARRAY.SKB.Admin',
    MICRO_ARRAY_EBE_FE_READ = 'MICRO_ARRAY.EBE_FE.Read',
    MICRO_ARRAY_EBE_FE_EDIT = 'MICRO_ARRAY.EBE_FE.Edit',
    MICRO_ARRAY_EBE_FE_ADMIN = 'MICRO_ARRAY.EBE_FE.Admin',
    MICRO_ARRAY_US_EBDI_READ = 'MICRO_ARRAY.US_EBDI.Read',
    MICRO_ARRAY_US_EBDI_EDIT = 'MICRO_ARRAY.US_EBDI.Edit',
    MICRO_ARRAY_US_EBDI_ADMIN = 'MICRO_ARRAY.US_EBDI.Admin',
    MIL_READ = 'NGS.MIL.Read',
    MIL_EDIT = 'NGS.MIL.Edit',
    MIL_ADMIN = 'NGS.MIL.Admin',
    MIL_GXP = 'NGS.MIL.GxP.Edit',

    NGS_TEST_READ = 'NGS.TEST.Read',
    NGS_TEST_EDIT = 'NGS.TEST.Edit',
    NGS_TEST_ADMIN = 'NGS.TEST.Admin',
    NGS_TEST_GXP = 'NGS.TEST.GxP.Edit',
    MICRO_ARRAY_TEST_READ = 'MICRO_ARRAY.TEST.Read',
    MICRO_ARRAY_TEST_EDIT = 'MICRO_ARRAY.TEST.Edit',
    MICRO_ARRAY_TEST_ADMIN = 'MICRO_ARRAY.TEST.Admin',
}

export type RoleState = {
    [key in Roles]?: boolean;
} & {
    [key: string]: boolean;
}
